<template>
  <div>
    <h3>隐私政策</h3>
    本协议为您与本应用管理者之间所订立的契约，具有合同的法律效力，请您仔细阅读。
    <h4>一、本协议内容、生效、变更。</h4>
    本协议内容包括协议正文及所有本应用已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。如您对协议有任何疑问，应向本应用咨询。您在同意所有协议条款并完成注册程序，才能成为本站的正式用户，您勾选“我已阅读并同意本应用用户协议和法律协议”按钮后，本协议即生效，对双方产生约束力。只要您使用本应用平台服务，则本协议即对您产生约束，届时您不应以未阅读本协议的内容或者未获得本应用对您问询的解答等理由，主张本协议无效，或要求撤销本协议。您确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
    您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用本应用平台服务。本应用有权根据需要不定期地制订、修改本协议及/或各类规则，并在本应用平台公示，不再另行单独通知用户。变更后的协议和规则一经在网站公布，立即生效。如您不同意相关变更，应当立即停止使用本应用平台服务。您继续使用本应用平台服务的，即表明您接受修订后的协议和规则。应用的版本升级，不影响双方原先的权力义务关系。
    <h4>二、用户资格</h4>
    用户须具有法定的相应权利能力和行为能力的自然人、法人或其他组织，能够独立承担法律责任。您完成服务购买或其他本应用平台同意的方式实际使用本平台服务时，即视为您确认自己具备主体资格，能够独立承担法律责任。若因您不具备主体资格，而导致的一切后果，由您及您的监护人自行承担。
    2.1用户应自行诚信向本站提供个人资料，用户同意其提供的资料真实、准确、完整、合法有效，用户资料如有变动的，应及时更新其资料。如果用户提供的资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且本应用保留终止用户使用本平台各项服务的权利。
    2.2用户在本站进行浏览等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。为完成创建账号，用户需提供以下信息：用户的姓名、身份证号、密码、户籍地址、家庭住址、手机号等信息。用户提供的上述信息，将在用户使用本服务期间持续授权我们使用。在用户注销账号时，我们将停止使用并删除上述信息。上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得用户的授权同意。
    <h4>三、账户</h4>
    3.1您购买服务成功后，即成为本应用平台的用户，将持有本应用平台唯一编号的账户信息，您可以根据本站规定改变您的密码。
    3.2您设置的姓名为真实姓名，不得侵犯或涉嫌侵犯他人合法权益。否则，本应用有权终止向您提供服务，注销您的账户。
    3.3用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
    3.4如果发现任何非法使用等可能危及您的账户安全的情形时，您应当立即以有效方式通知本应用要求暂停相关服务，并向公安机关报案。您理解本应用对您的请求采取行动需要合理时间，本应用对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
    <h4>四、用户信息的合理使用</h4>
    4.1您同意本应用平台拥有通过邮件、短信电话等形式，向在本站注册用户发送信息等告知信息的权利。
    4.2您了解并同意，本应用有权应国家司法、行政等主管部门的要求，向其提供您在本应用平台填写的个人信息和交易记录等必要信息。如您涉嫌侵犯他人知识产权，则本应用亦有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供您必要的身份信息。
    4.3用户同意本应用有权使用用户的个人信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。
    <h4>五、免责条款</h4>
    5.1
    本平台仅提供信息对接，发生一切纠纷问题皆与本平台无关，请通过仲裁部门维护各自权益。
  </div>
</template>

<script>
export default {};
</script>

<style>
h3 {
  font-size: 20px;
  margin: 10px 0;
  padding: 0;
  line-height: 35px;
  font-weight: 600;
}
h4 {
  font-size: 18px;
  margin: 15px 0;
  padding: 0;
  font-weight: 600;
}
div {
  font-weight: 400;
  font-size: 16px;
  padding: 8px 8px;
  line-height: 23px;
}
</style>
